import { Component, HostListener, OnInit } from "@angular/core";
import { ContentService } from "../../shared/services/content.service";
import { Meta } from "@angular/platform-browser";

@Component({
  selector: "app-danvi",
  templateUrl: "./danvi2.component.html",
  styleUrls: ["./danvi2.component.scss"],
})
export class Danvi2Component implements OnInit {
  page: Object;

  constructor(private contentService: ContentService, private meta: Meta) {
    this.meta.addTags([
      {
        name: "title",
        content: "",
      },

      {
        name: "description",
        content: "",
      },
    ]);
  }
  ngOnInit() {
    this.page = this.contentService.pages["danvi2"];
  }
}
